import React from 'react';
import { Star, Shield, XCircle, Gift } from 'lucide-react';

/**
 * TrustBadges - Primary trust badge row in hero section
 * Shows: Google Reviews, Free Cancellation, Complimentary Meet & Greet
 * Design: Subtle border style, not aggressive green
 */
const TrustBadges = ({ showFreeCancellation = true }) => {
  const badges = [
    {
      icon: <Star className="h-4 w-4 text-primary fill-primary" />,
      label: 'Google Reviews',
      value: '4.9/5',
      highlight: false,
      href: 'https://search.google.com/local/writereview?placeid=ChIJy_493HvDLWcRdiQR-87vf-k',
    },
    {
      icon: <XCircle className="h-4 w-4 text-emerald-500" />,
      label: 'Free',
      value: 'Cancellation',
      highlight: true,
      href: null,
    },
    {
      icon: <Gift className="h-4 w-4 text-emerald-500" />,
      label: 'Complimentary',
      value: 'Meet & Greet',
      highlight: true,
      href: null,
    },
  ];

  return (
    <div className="flex flex-wrap gap-3">
      {badges.map((badge, index) => {
        const content = (
          <>
            {badge.icon}
            <div className="flex flex-col">
              <span className={`text-xs ${badge.highlight ? 'text-emerald-500' : 'text-muted-foreground'}`}>
                {badge.label}
              </span>
              <span className={`text-sm font-semibold ${badge.highlight ? 'text-foreground' : 'text-foreground'}`}>
                {badge.value}
              </span>
            </div>
          </>
        );

        // Badge styling: subtle border for highlighted, normal for others
        const badgeClass = badge.highlight 
          ? 'trust-badge border-emerald-500/30 bg-emerald-500/5'
          : 'trust-badge';

        if (badge.href) {
          return (
            <a
              key={index}
              href={badge.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`${badgeClass} hover:border-primary/50 transition-colors`}
              data-testid={`trust-badge-${index}`}
            >
              {content}
            </a>
          );
        }

        return (
          <div 
            key={index} 
            className={badgeClass}
            data-testid={`trust-badge-${index}`}
          >
            {content}
          </div>
        );
      })}
    </div>
  );
};

export default TrustBadges;
